<template>
    <rkm-layout-body title="Lista de fabricante">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-fabricante-create' })"
                color="primary"
                authorize="store-cadastro-fabricante"
            >
                Cadastrar fabricante
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/fabricante/List'

export default {
    components: { List },
}
</script>